import type { ICustomControlRequestAddEditProps } from '../../interfaces/';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { ServiceCode } from '../../../../../../common/enums/serviceCode';
import { translateKey } from '../../../../../translate';
import { useCheckHasOrthOInLastSixMonths } from '../../../../../utils/hooks/useCheckHasOrthOInLastSixMonths';
import { useEpisodeContext } from '../../../../../utils/hooks/useEpisodeContext';
import { OrthOAlert } from '../../OrthO/OrthOAlert';
import { OrthopticsV1RequestAddEdit } from '../../OrthO/OrthopticsV1RequestAddEdit';
import { NewOrEditRequestProcessContainer } from '../../utils/v1/NewOrEditRequestProcessContainer';

export function OrthOFolV1RequestAddEdit(props: ICustomControlRequestAddEditProps) {
    const { patient } = useEpisodeContext();
    const hasOrthOInLastSixMonths = useCheckHasOrthOInLastSixMonths(patient.id);

    return (
        <NewOrEditRequestProcessContainer
            isExaminationRequest={true}
            isFirstItem={props.isFirstItem}
            itemState={props.itemState}
            process={props.process}
            service={props.service}
            title={getServiceLabel(props.service.code, 'request', props.service.name)}
        >
            {!props.request.id && hasOrthOInLastSixMonths === false && (
                <OrthOAlert
                    buttonText={translateKey('orthOProcedure.convert_to_first_ortho')}
                    serviceCodeForButton={ServiceCode.OrthO}
                    text={translateKey('orthOProcedure.no_previous_ortho')}
                />
            )}

            <OrthopticsV1RequestAddEdit
                isOrthOFol={true}
                {...props}
            />
        </NewOrEditRequestProcessContainer>
    );
}

export function orthOFolV1RequestInitializeCustomControlData() {
    return {
        reden_van_verwijzing: {
            hoofdpijn: false,
            geleidelijke_daling_gezichtsscherpte_bij_kind: false,
            scheelzien_altijd_geleidelijk: false,
            geleidelijk_ontstaan_langer_bestaand_binoculair_dubbelzien: false,
            asthenope_klachten: false,
            vervolg_onderzoek: false,
            andersText: null,
        },
        omschrijf_de_duur_van_de_klachten: null,
        relevante_medische_voorgeschiedenis: null,
        oculaire_voorgeschiedenis: null,
        familiaire_voorgeschiedenis: null,
        isPatientInformed: false,
        toelichting: null,
    };
}
